import React from 'react';
import { Box, Text } from '@common-fe/common-fe';

import Modal from '@/components/elements/AutoBlockedModal/Modal';

interface Props {
  visible: boolean;
  onSetVisible: (value: boolean) => void;
  title?: string;
  testId?: string;
  children: React.ReactNode;
  id?: string;
  wrapperStyle?: React.CSSProperties;
  isClosingByClickOutsideBlocked?: boolean;
}

const ModalWrapper: React.FC<Props> = ({
  title,
  children,
  onSetVisible,
  visible,
  testId,
  id,
  wrapperStyle,
  isClosingByClickOutsideBlocked,
}) => (
  <Modal id={id} testId={testId} visible={visible} onSetVisible={onSetVisible} wrapperStyle={wrapperStyle} isClosingByClickOutsideBlocked={isClosingByClickOutsideBlocked}>
    <Box direction="column" data-testid={`${testId}_modal`}>
      <Box direction="row" align="center" justify="center" pad={{ bottom: 'spacing24' }}>
        {title && <Text size="2xl" color="textTitle" weight="bold">{title}</Text>}
      </Box>
      <Box>
        {children}
      </Box>
    </Box>
  </Modal>
);

export default ModalWrapper;
